module.exports = __webpack_public_path__ + "static/img/58357043-c7ac-4a66-aa70-2970dd5cbf78.34fbe86.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/58357043-c7ac-4a66-aa70-2970dd5cbf78.png
// module id = U7GH
// module chunks = 1